/**
 * Created by zjs on 2017/09/28
 * 单据类页面状态管理
 */

import actions from './actions'
import mutations from './mutations'

const state = {
    searchForm: {}, // 记录单据类列表的搜索条件
    copyInfo: {} // 复制单据，存放的信息，主要有单据路由名和ID
}

const getters = {
    searchForm: state => state.searchForm,
    copyInfo: state => state.copyInfo
}

export default {
    state,
    getters,
    actions,
    mutations
}